import { addLocalBusinessJSONLD } from "../localBusiness"
import { addFaqBagsterJSONLD } from "../faqBagster"
import { addvistaLandFillJSONLD } from "../vistaLandFill"
import { addBusinessWasteRecyclingPickUp } from "../businessWasteRecyclingPickUp.js"
import { addResidentialWasteRecyclingPickUp } from "../residentialWasteRecyclingPickUp.js"
import { addEcoVistaLandFillJSONLD } from "../ecoVistaLandFill"
import { addSouthernServicesLandfillJSONLD } from "../southernServicesLandfill"
import { addDumpsterRental } from "../dumpsterRental"
import { addSustainabilityForum } from "../sustainabilityForum"
import { addBulkTrashPickup } from "../largeBulkPickup"
import { addFaqMoveJSONLD } from "../faqMoving"
import { addRequestInvoice } from "../requestInvoice"
import { addLinkMoreThanOneAccount } from "../linkMoreThanOneAccount"
import { addUnenrollAutomaticPayment } from "../unenrollAutomaticPayment"
import { addGravityLockData } from "../gravityLock"
import { addEnrollAutomaticPaymentData } from "../enrollAutomaticPayment"
import { addRecycleWrappingPaper } from "../recycleWrappingPaper"
import { addManageMyAccount } from "../manageMyAccount"
import { addHelpWithBilling } from "../helpWithBilling"
import { addConnectToRequestContainer } from "../connectToRequestContainer"
import { addRequestServiceOnRollOff } from "../requestServiceOnRollOff"
import { addRecycleElectronics } from "../recycleElectronics"
import { addRequestExtraPickup } from "../requestExtraPickup"
import { addViewMyPickupSchedule } from "../viewMyPickupSchedule"
import { addLinkFirstAccountData } from "../linkFirstAccount"
import { addRequestNewService } from "../requestNewService"
import { addwhatIfPickUpDateOnHoliday } from "../whatIfPickUpDateOnHoliday"
import { addwhatIsMyNextPixkup } from "../whatIsMyNextPixkup"
import { addhowIRequestExtraPickUp } from "../howIRequestExtraPickUp"
import { addsevereWeatherNotified } from "../severeWeatherNotified"
import { addwinteriseMyFarm } from "../winteriseMyFarm"
import { adddisposeStrashAfterStorm } from "../disposeStrashAfterStorm"
import { addstayGreenDuringHoliday } from "../stayGreenDuringHoliday"
import { addholidayAffectNewContainer } from "../holidayAffectNewContainer"
import { adddelayDuringHoliday } from "../delayDuringHoliday"
import { addmyServiceDuringMoving } from "../myServiceDuringMoving"
import { addchangeContainerSize } from "../changeContainerSize"
import { addchangePickupFrequency } from "../changePickupFrequency"
import { addserviceOnVacationHold } from "../serviceOnVacationHold"
import { addcancelAService } from "../cancelAService"
import { addeditCancelReturnRequest } from "../editCancelReturnRequest"
import { addcancelChaangeOrderRequest } from "../cancelChaangeOrder"
import { addgetMyContainerRepaired } from "../getMyContainerRepaired"
import { addlockForMyContainerRequest } from "../lockForMyContainer"
import { addcontainerDeliveryWork } from "../containerDeliveryWork"
import { addprepareForPickup } from "../prepareForPickup"
import { addhandleOdourContainer } from "../handleOdourContainer"
import { addcontainerRelocated } from "../containerRelocated"
import { addpermitContainerPlacement } from "../permitContainerPlacement"
import { addreportStolenContainer } from "../reportStolenContainer"
import { addSchemaDetails } from "../addSchemaDetails"
import {
  updateWebsiteJSONLD,
  updatebrandJSONLD,
  updateOrganizationJSONLD,
} from "../homepage"
import { addReportMissedPickUp } from "../reportMissedPickup"
import { addrecyclingScheduledServiceOtherWeek } from "../recyclingScheduledServiceOtherWeek"

export default () => {
  /* Add Local Business JSON LD if needed, otherwise make sure it does not exist in Head. */
  addvistaLandFillJSONLD()
  addBusinessWasteRecyclingPickUp()
  addResidentialWasteRecyclingPickUp()
  addEcoVistaLandFillJSONLD()
  addSouthernServicesLandfillJSONLD()
  addDumpsterRental()
  addSustainabilityForum()
  addBulkTrashPickup()
  addFaqBagsterJSONLD()
  addFaqMoveJSONLD()
  addLocalBusinessJSONLD()
  addRequestNewService()
  addwhatIfPickUpDateOnHoliday()
  addwhatIsMyNextPixkup()
  addhowIRequestExtraPickUp()
  addsevereWeatherNotified()
  addwinteriseMyFarm()
  adddisposeStrashAfterStorm()
  addstayGreenDuringHoliday()
  addholidayAffectNewContainer()
  adddelayDuringHoliday()
  addmyServiceDuringMoving()
  addchangeContainerSize()
  addchangePickupFrequency()
  addcancelChaangeOrderRequest()
  addgetMyContainerRepaired()
  addlockForMyContainerRequest()
  addcontainerDeliveryWork()
  addprepareForPickup()
  addhandleOdourContainer()
  addcontainerRelocated()
  addpermitContainerPlacement()
  addreportStolenContainer()
  addserviceOnVacationHold()
  addcancelAService()
  addeditCancelReturnRequest()
  addRequestInvoice()
  addRequestExtraPickup()
  addGravityLockData()
  addViewMyPickupSchedule()
  addManageMyAccount()
  addRecycleElectronics()
  addEnrollAutomaticPaymentData()
  addLinkMoreThanOneAccount()
  addUnenrollAutomaticPayment()
  addRequestServiceOnRollOff()
  addRecycleWrappingPaper()
  addLinkFirstAccountData()
  addHelpWithBilling()
  addConnectToRequestContainer()
  addReportMissedPickUp()
  addrecyclingScheduledServiceOtherWeek()
  addSchemaDetails()

  /* Add common JSON LD if needed, require help to update when history change */
  updateWebsiteJSONLD()
  updatebrandJSONLD()
  updateOrganizationJSONLD()
}
